import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    StyleSheet,
    FlatList
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDImage,
    JDLogin,
    JDConfirmDialog,
    JDJumping,
    JDAlertDialog
} from '@jdreact/jdreact-core-lib';

import { format_date, tip, mtaPV, mta, closeShare, is_web } from '../common/utils';
import { get, post } from '../common/fetch';
import { NavBar, utils } from '@ltfe/ltfe-core-lib';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import Loading from '../components/common/loading';
import WifiOut from '../components/common/wifi-out';
import QRCode from '../components/common/QR-code';
import CountDown from '../components/common/count-down';
import NoMore from '../components/common/no-more';
import sgmReport from '../common/sgmUtil';

const { pt } = utils;

class OrderList extends PureComponent {
    constructor(props) {
        super(props);
        this.isLoadingMore = false;
        this.state = {
            page: 1,
            // pageSize:1,
            loading: false,
            listInfo: [
                // {
                //     "businessType": 2,
                //     "buyTime": 1536581240000,
                //     "cinemaId": 179568,
                //     "cinemaName": "金逸j国际影城-北京双桥店",
                //     "cityName": "北京",
                //     "issueInfo": "国语 2D 4号激光厅（冠名招商中）",
                //     "jdErpId": "56289624288",
                //     "mobile": "18622222222",
                //     "movieId": "61152",
                //     "onlineMoney": 4400,
                //     "orderStatus": 1,
                //     "orderStatusDesc": "等待付款",
                //     "payStatus": 1,
                //     "payType": 1,
                //     "qrCodeUrl": null,
                //     "redeemCodeSms": null,
                //     "seatsChosen": [
                //         "7排5座",
                //         "7排6座"
                //     ],
                //     "showTime": 1536581240000,
                //     "ticketCode": null,
                //     "ticketCount": 1,
                //     "ticketPwd": null,
                //     "totalAmount": 4400,
                //     "totalDiscount": 0
                // }
            ],
            cancelOrder: false,
            erpOrderId: null,
            hasError: false,
            /* 用于触发render */
            orderIndex: 0,
            isErrShow: false,
            errMsg: ''
        };
        this.getInfo = this.getInfo.bind(this);
        this._renderItemComponent = this._renderItemComponent.bind(this);
        this.changeLabel = this.changeLabel.bind(this);

        this.errFn = this.errFn.bind(this);
        this._cancelOrder = this._cancelOrder.bind(this);
        this._goPay = this._goPay.bind(this);
        this._agreeCancel = this._agreeCancel.bind(this);
        this._onClose = this._onClose.bind(this);
        this._toOrderDetail = this._toOrderDetail.bind(this);
        this.refresh = this.refresh.bind(this);
        this.onScrollEndDrag = this.onScrollEndDrag.bind(this);
    }

    render() {
        const { listInfo, loading, cancelOrder, hasError, orderIndex, isErrShow, errMsg } = this.state;

        if (hasError) {
            return (
                <View style={ st.context }>
                    { this.setTitle('电影票订单') }
                    <WifiOut refresh={ this.refresh } contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />
                </View>
            );
        }

        return (
            <View style={ st.context }>
                {/* <NavigationBar LeftButton={this.changeLabel} Title="电影票订单"/>      */}
                { this.setTitle('电影票订单') }

                {loading
                    ? <FlatList
                        showsVerticalScrollIndicator={ false }
                        data={ listInfo }
                        // data={[]}
                        ref="listbody"
                        onScrollEndDrag={ (event) => this.onScrollEndDrag }
                        onMomentumScrollEnd={ (event) => this.onScrollEndDrag }
                        renderItem={ this._renderItemComponent }
                        keyExtractor={ (item, index) => index + '' }
                        ListEmptyComponent={ () => <View style={ { marginTop: pt(130) } }><NoMore txt={ '暂时还没有订单哦' } btnTxt={ '去首页看看' } btnFn={ () => { is_web ? this.context.router.toIndex() : this.context.router.resetTo({ routeName: 'index' }); } } /></View> }
                        onEndReachedThreshold={ 0.05 }
                        onEndReached={ this.getInfo }
                        initialNumToRender={ 6 }
                    />
                    : <Loading contentStyle={ { flex: 1, height: '100%', backgroundColor: '#fff' } } />}

                {/* 确定取消订单错误提示 */}
                <JDAlertDialog show={ isErrShow } okText="返回首页" onButtonClick={ this.errFn }>
                    <View>
                        <JDText>{errMsg}</JDText>
                    </View>
                </JDAlertDialog>

                <JDConfirmDialog show={ cancelOrder } onConfirm={ this._agreeCancel } onClose={ this._onClose }>
                    <View style={ st.dialogBody }>
                        <JDText style={ st.c_title }>是否确定取消订单</JDText>
                        <JDText>取消订单后您选择的座位将会被释放，虚拟资产部分稍后会退至您的账户</JDText>
                    </View>
                </JDConfirmDialog>

            </View>
        );
    }

    componentDidFocus() {
        mtaPV('OrdList');

        const { listInfo } = this.state;
        // 返回时重新获取上一个订单最新状态

        if (global.order) {
            const info = global.order;

            this.resetList(info.erpOrderId, info.orderStatusDesc, info.orderStatus);
        }
        global.order = null;
    }

    componentDidMount() {
        const { dispatch } = this.props;

        const _this = this;

        JDLogin.isLogin().then(() => {
            jump();
        }, () => {
            JDLogin.doLogin().then(() => {
                jump();
            });
        }).catch(() => jump());

        function jump() {
            _this.getInfo();
        }
        closeShare();
    }

    changeLabel() {
        const { dispatch } = this.props;

        const fn = () => {
            dispatch({
                type: 'change_label',
                label: 0
            });
        };

        return (
            <JDTouchable onPress={ fn }>
                <JDText>回到首页</JDText>
            </JDTouchable>
        );
    }

    setTitle = (title) => {
        document.title = title;
    }

    /* 取消订单 */
    _cancelOrder(erpOrderId) {
        mta('OrdListCancel', 'OrdList', `${erpOrderId}`);

        this.setState({
            cancelOrder: true,
            erpOrderId
        });
    }

    /* 确定取消 */
    _agreeCancel() {
        const { erpOrderId, listInfo, orderIndex } = this.state;

        this.setState({
            cancelOrder: false
        });
        // 取消订单
        post('cancelMovieOrder', { erpOrderId }, true).then(res => {
            const code = res.errCode;

            if (code === 5000) {
                tip('系统有点忙，请稍后重试');

                return;
            }

            if (code === 2100) {
                this.setState({
                    isErrShow: true,
                    errMsg: '系统没有找到这个订单，请联系客服400-616-5718'
                });

                return;
            }

            if (code === 2101) {
                this.resetList(erpOrderId);
                tip('该订单已支付或超时取消');

                return;
            }

            tip('订单取消成功');

            this.resetList(erpOrderId, '已取消');

            // this.getInfo(1)
        }).catch((err) => {
            tip('订单取消失败');
        });

        if(!erpOrderId){
            sgmReport('1001', {function_id: 'cancelMovieOrder',message:'缺少参数erpOrderId'}, 3)
        }
    }

    errFn() {
        this.setState({
            isErrShow: false
        });
        is_web ? this.context.router.toIndex() : this.context.router.resetTo({ routeName: 'index' });
    }

    /* 设置当前订单不展示取消和去支付按钮 */
    resetList(erpOrderId, txt, type) {
        const { listInfo, orderIndex } = this.state;

        const info = listInfo;

        listInfo.forEach((item, index) => {
            if (item.jdErpId == erpOrderId) {
                info[index].payStatus = type || 3;
                info[index].orderStatus = type || 3;
                info[index].orderStatusDesc = txt || '';
            }
        });
        this.setState({
            listInfo: info,
            orderIndex: (orderIndex + 1)
        });
    }

    /* 去支付 */
    _goPay(erpOrderId) {
        const { listInfo, orderIndex } = this.state;
        // const { erpOrderId } = this.state

        mta('OrdListPay', 'OrdList', `${erpOrderId}`);

        // 去支付
        post('getPayUrl', { erpOrderId }).then(res => {
            const code = res.errCode;

            // 2101 订单状态更新  2901 已取消 2902 已付款
            if (code === 2101 || code === 2901 || code === 2902) {
                const cancel = code === 2901 ? '已取消' : '已付款';
                /* 订单状态更新，手动更新当前状态 */

                this.resetList(erpOrderId);

                tip(code === 2101 ? '订单已付款' : '订单已取消');

                return;
            }

            if (res.data.url) {
                JDJumping.jumpToWeb(res.data.url).catch(err => tip(err));
            }
        });

        if(!erpOrderId){
            sgmReport('1001', {function_id: 'getPayUrl',message:'缺少参数erpOrderId'}, 3)
        }
    }

    /* 关闭取消订单弹层 */
    _onClose() {
        this.setState({
            cancelOrder: false
        });
    }

    _renderItemComponent(item) {
        return (
            <ItemComponent
                data={ item }
                // timeOut={() => this.getInfo(1)}
                goPay={ this._goPay }
                cancelShow={ this._cancelOrder }
                toOrderDetail={ this._toOrderDetail }
            />
        );
    }

    onScrollEndDrag(event) {
        this.setState({
            offsetY: event.nativeEvent.contentOffset.y
        });
    }

    /**
     * type 倒计时更新入参
     */

    getInfo(type) {
        const { page, listInfo, pageSize, offsetY } = this.state;
        const { userPin } = this.props;

        if (this.isLoadingMore) {
            return;
        }
        this.isLoadingMore = true;

        if (pageSize == page) {
            return;
        }
        const size = 10;

        const _this = this;

        get('getOrderList', {
            // userPin: '820612866_751339222',
            // userPin: userPin,
            pageNum: page,
            pageSize: size
        }, true).then((res) => {
            if (!res.data) {
                this.setState({
                    page: page,
                    pageSize: page
                });
            } else {
                this.setState({
                    listInfo: listInfo.concat(res.data),
                    page: (page + 1)
                }, () => {
                    if (offsetY) {
                        setTimeout(() => {
                            // _this.refs.listbody.scrollTo({ x: 0, y: offsetY, animated: false})

                        }, 400);
                    }
                });

                if(res.data && res.data.length){
                    const hasEmpty = res.data.some(item => !item.jdPicAddr);
                    if(hasEmpty){
                        sgmReport('1002', {function_id: 'getOrderList',message:'数据未返回图片地址！'}, 3)
                    }
                }
            }
            this.setState({
                loading: true,
                hasError: false
            });

            this.isLoadingMore = false;
        }).catch((err) => {
            this.setState({
                hasError: true
            });
            this.isLoadingMore = false;
        });
    }

    _toOrderDetail(val) {
        this.setState({
            erpOrderId: val.jdErpId
        });

        mta('OrdListItem', 'OrdList', `${val.jdErpId}`);

        this.context.router.toOrderDetail({ erpOrderId: val.jdErpId, movieId: val.movieId });
    }

    refresh() {
        this.setState({ loading: true, hasError: false });
        get('getOrderList', {
            // userPin: '820612866_751339222',
            // userPin: userPin,
            pageNum: 1,
            pageSize: 10
        }, true).then((res) => {
            if (!res.data) {
                this.setState({
                    page: 1,
                    pageSize: 1
                });
            } else {
                this.setState({
                    listInfo: res.data,
                    page: (2)
                });

                if(res.data && res.data.length){
                    const hasEmpty = res.data.some(item => !item.jdPicAddr);
                    if(hasEmpty){
                        sgmReport('1002', {function_id: 'getOrderList',message:'数据未返回图片地址！'}, 3)
                    }
                }
            }
            this.setState({
                loading: true,
                hasError: false
            });
        }).catch((err) => {
            this.setState({
                hasError: true
            });
        });
    }
}

class ItemComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { data, timeOut, goPay, cancelShow, toOrderDetail } = this.props;

        const val = data.item;

        return (
            <View style={ st.list }>

                {false && <CountDown style={ { top: pt(4) } } timeOut={ timeOut } minutes={ '0' } seconds={ '9' } />}

                <View style={ { paddingHorizontal: pt(10) } }>
                    <JDTouchable onPress={ () => { toOrderDetail(val); } }>
                        <View style={ st.head }>
                            <JDText numberOfLines={ 1 } style={ st.name }>{val.cinemaName}</JDText>

                            <JDText style={ [st.desc, [3, 4].some((item) => val.orderStatus == item) && st.gray] }>{val.orderStatusDesc}</JDText>
                        </View>

                        <View style={ st.movie }>
                            <JDImage style={ st.img } source={ { uri: val.jdPicAddr } } />
                            <View style={ st.m_info }>
                                <JDText style={ st.m_title } numberOfLines={ 1 }>{val.movieName}</JDText>
                                <JDText style={ st.m_txt }>{format_date(val.showTime)}</JDText>
                                <JDText style={ st.m_txt }>{val.issueInfo}</JDText>
                                <JDText style={ st.m_txt }>
                                    {val.seatsChosen && val.seatsChosen.length > 0 ? val.seatsChosen.join('、') : val.seatsChosen}
                                </JDText>
                            </View>
                        </View>
                    </JDTouchable>

                    <View style={ st.bottom }>

                        <View>
                            <JDText style={ st.price_a }>实付款：&yen;<JDText style={ st.price }>{(val.onlineMoney / 100)}</JDText></JDText>
                        </View>
                        {/* COMMM */}
                        {/* <View style={st.btn}>

                            <JDTouchable onPress={() => cancelShow(val.jdErpId)} >
                                <View>
                                    <JDImage style={st.b_img} source={img.b_gray}>
                                        <JDText style={st.b_cancel}>取消订单</JDText>
                                    </JDImage>
                                </View>
                            </JDTouchable>
                            <JDTouchable onPress={() => goPay(val.jdErpId)}>
                                <View>
                                    <JDImage style={st.b_img} source={img.b_red}>
                                        <JDText style={st.b_pay}>去支付</JDText>
                                    </JDImage>
                                </View>
                            </JDTouchable>
                        </View> */}
                        {/* COMMM */}

                        {
                            (val.payStatus == 1 && val.orderStatus == 1) &&
                            <View style={ st.btn }>

                                <JDTouchable onPress={ () => cancelShow(val.jdErpId) } >
                                    <View style={ st.view_btn }>
                                        <JDText style={ st.b_cancel }>取消订单</JDText>
                                    </View>
                                </JDTouchable>

                                <JDTouchable onPress={ () => goPay(val.jdErpId) }>
                                    {/* <View style={[st.view_btn,{borderWidth:0}]}> */}
                                    <LinearGradient style={ [st.view_btn, { borderWidth: 0 }] } colors={ ['#F10000', '#FF2000', '#FF4F18'] } start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                                        <JDText style={ st.b_pay }>去支付</JDText>
                                    </LinearGradient>
                                    {/* </View> */}
                                </JDTouchable>

                            </View>
                        }

                    </View>

                    {
                        val.orderStatus == 5 && (val.ticketPwd || val.ticketCode) && val.qrCodeUrl
                            ? <QRCode codeInfo={ {
                                ticketPwd: val.ticketPwd,
                                ticketCode: val.ticketCode,
                                qrCodeUrl: val.qrCodeUrl
                            } } islist={ true } />
                            : null
                    }
                </View>
            </View>
        );
    }
}

OrderList.contextTypes = {
    router: PropTypes.object
};

const select = (state) => {
    const props = state.index;

    return {
        userPin: props.userPin
    };
};

export default connect(select, null, null, { withRef: true })(OrderList);

const st = StyleSheet.create({
    context: {
        flex: 1,
        // width: pt(375),
        backgroundColor: '#f5f5f5'
    },
    list: {
        marginTop: pt(6),
        backgroundColor: '#fff'
    },
    head: {
        borderBottomWidth: pt(1),
        borderColor: '#f3f3f3',
        height: pt(43),
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    movie: {
        marginTop: pt(11),
        marginBottom: pt(13),
        flexDirection: 'row'
    },
    img: {
        height: pt(88),
        width: pt(65),
        marginRight: pt(9)
    },
    m_info: {
        width: pt(280),
        justifyContent: 'space-around'
    },
    m_txt: {
        color: '#666',
        fontSize: pt(12)
    },
    m_title: {
        color: '#000',
        fontSize: pt(16),
        width: '100%'
    },
    name: {
        fontSize: pt(12)
    },
    desc: {
        fontSize: pt(12),
        color: '#252525'
    },
    gray: {
        color: '#666'
    },
    bottom: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTopWidth: pt(1),
        borderColor: '#f3f3f3',
        height: pt(54)
    },
    price_a: {
        fontSize: pt(12),
        color: '#252525'
    },
    price: {
        fontSize: pt(15),
        fontWeight: 'bold'
    },
    btn: {
        width: pt(180),
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row'
    },
    view_btn: {
        width: pt(82),
        height: pt(30),
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: pt(1),
        borderColor: '#ccc',
        borderRadius: pt(15),
        overflow: 'hidden'
    },
    b_cancel: {
        color: '#666',
        fontSize: pt(12)
    },
    b_pay: {
        color: '#fff',
        fontSize: pt(12),
        backgroundColor: 'transparent'
    },
    dialogBody: {
        padding: pt(20),
        justifyContent: 'center',
        alignItems: 'center'
    },
    c_title: {
        fontSize: pt(14),
        fontWeight: 'bold',
        paddingBottom: pt(10)
    }
});
